var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"px-2.5 py-1.5 border border-transparent text-xs rounded shadow-sm text-white bg-blue-400 hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 text-center transition",attrs:{"type":_vm.type}},_vm.$listeners),[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }